import TreeMapFilterItem from "../tree-map-filter-item";
import TreeMapSubFilterCard from "../tree-map-sub-filter-card";

import { useTreeMapFilterAssetConditionRating } from "./tree-map-filter-asset-condition-rating.hook";

const TreeMapFilterAssetConditionRating = () => {
  const { filterItems, onToggle } = useTreeMapFilterAssetConditionRating();

  return (
    <TreeMapSubFilterCard type="conditionRating">
      {filterItems.map(({ rating, name, color, count, checked, disabled }) => (
        <TreeMapFilterItem
          key={rating}
          title={name}
          count={count}
          color={color}
          checked={checked}
          disabled={disabled}
          onToggle={() => onToggle(rating, checked)}
        />
      ))}
    </TreeMapSubFilterCard>
  );
};

export default TreeMapFilterAssetConditionRating;
